import { clientApi } from 'api';
import { IByTokenResponse } from 'types/Auth';

export const userByToken = (isServer = false) => async () => {
  const response = await clientApi.get<IByTokenResponse>('/users/by-token');

  return response.data;
};
